import type { useRouter } from "@/lib/router-compat";

/**
 * Eager route preload for call sites that are not `<Link>` (KPI cards,
 * bottom-tab buttons, logo). `<Link preload="intent">` — TanStack Router's
 * default under `createRouter({ defaultPreload: "intent" })` — handles the
 * rest automatically on hover/touch/focus.
 *
 * Thin wrapper around `router.prefetch()` (the compat shim forwards to
 * `router.preloadRoute({ to })`). TanStack dedupes internally so calling
 * this on every hover + touchstart is free. Kept as a dedicated symbol so
 * the call sites remain a grep-able seam.
 */
export function preloadRoute(
  href: string,
  router: ReturnType<typeof useRouter>,
): void {
  router.prefetch(href);
}
